import { useLanguage } from "@/i18n/LanguageContext";
import { Truck, Home, Briefcase, Clock, Shield, Zap } from "lucide-react";

const ICONS = [Truck, Home, Briefcase, Clock, Shield, Zap];

export default function Services() {
  const { t } = useLanguage();

  return (
    <section
      id="services"
      data-testid="services-section"
      className="py-24 lg:py-32 bg-white"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-2xl mb-16">
          <div className="inline-block mb-6">
            <span
              data-testid="services-tag"
              className="text-xs font-bold tracking-[0.2em] uppercase text-red-600 font-body"
            >
              {t.services.tag}
            </span>
            <div className="w-full h-0.5 bg-red-600 mt-1" />
          </div>
          <h2
            data-testid="services-title"
            className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight leading-none text-gray-900 font-heading"
          >
            {t.services.title}
          </h2>
        </div>

        {/* Bento Grid */}
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-px bg-gray-200 border border-gray-200">
          {t.services.items.map((item, idx) => {
            const Icon = ICONS[idx];
            return (
              <div
                key={item.title}
                data-testid={`service-card-${idx}`}
                className="bg-white p-8 lg:p-10 group hover:bg-gray-50 transition-colors duration-300"
              >
                <div className="w-12 h-12 bg-red-600 flex items-center justify-center mb-6 group-hover:bg-red-700 transition-colors duration-300">
                  <Icon className="w-6 h-6 text-white" strokeWidth={2} />
                </div>
                <h3 className="text-xl font-bold text-gray-900 font-heading mb-3">
                  {item.title}
                </h3>
                <p className="text-sm leading-relaxed text-gray-500 font-body">
                  {item.description}
                </p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
